var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-toasts"},_vm._l((_vm.toasts),function(toast,i){return _c('div',{key:("toast_" + i),staticClass:"toast",class:{
      error: toast.type === 'error',
      success: toast.type === 'success',
      info: toast.type === 'info'
    }},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(toast.text))]),_c('a',{staticClass:"close",on:{"click":function($event){return _vm.removeToast(toast)}}},[_c('i',{staticClass:"fas fa-times"})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }